import React from 'react';
import Booking from '../../components/Booking/Booking';
import './BookingPage.css';

const BookingPage = () => {
  return (
    <div className="booking-page">
      <Booking />
    </div>
  );
};

export default BookingPage;